import { render, staticRenderFns } from "./CaseConfigTasks.vue?vue&type=template&id=2e8d2521"
import script from "./CaseConfigTasks.vue?vue&type=script&lang=js"
export * from "./CaseConfigTasks.vue?vue&type=script&lang=js"
import style0 from "./CaseConfigTasks.vue?vue&type=style&index=0&id=2e8d2521&prod&stylus=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports